/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_ContactInputs */

const en_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const fr_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const es_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const it_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatti`)
};

const nl_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const pl_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const fi_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteystiedot`)
};

const da_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const sv_landing_footer_contact = /** @type {(inputs: Landing_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Landing_Footer_ContactInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_footer_contact = /** @type {((inputs?: Landing_Footer_ContactInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_ContactInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_footer_contact(inputs)
	if (locale === "fr") return fr_landing_footer_contact(inputs)
	if (locale === "es") return es_landing_footer_contact(inputs)
	if (locale === "it") return it_landing_footer_contact(inputs)
	if (locale === "nl") return nl_landing_footer_contact(inputs)
	if (locale === "pl") return pl_landing_footer_contact(inputs)
	if (locale === "fi") return fi_landing_footer_contact(inputs)
	if (locale === "da") return da_landing_footer_contact(inputs)
	if (locale === "sv") return sv_landing_footer_contact(inputs)
	return en_landing_footer_contact(inputs)
});